// Whether the security banner is on screen, for its skip link (B27 with the mock's placement:
// the banner sits in the content column, after the rail, so a first Tab stop leads to it).
export const securityBannerPresence = $state({ open: false });

/** Focus the banner's first action ("It was me", or "Not me" on the flagged session). */
export function focusSecurityBanner(): void {
  document
    .querySelector<HTMLButtonElement>("[data-security-banner] button:not([disabled])")
    ?.focus();
}
